/* eslint no-param-reassign:  ["error", { "props": false }] */
/* eslint no-shadow: 0 */

import { get } from 'lodash';
import { chatGetUserChannels, getPrivateChatList } from '@/api';
import {
  GET_CHAT_USER_CHANNELS,
  GET_CHAT_PRIVATE_LIST,
  LOADING_CHAT_PRIVATE_LIST,
  LOADING_CHAT_USER_CHANNELS,
} from '@/store/mutation-types';

const state = {
  user_profiles: [],

  squadsLoading: false,
  squads: [],
  squadsTake: 20,
  squadsSkip: 0,
  squadsExhausted: false,

  privateMessagesLoading: false,
  privateMessages: [],
  privateMessagesTake: 20,
  privateMessagesSkip: 0,
  privateMessageExhausted: false,
};


const getters = {
  squads(state) {
    return state.squads || [];
  },
  userProfiles(state) {
    return state.user_profiles || [];
  },
  privateMessages(state) {
    return state.privateMessages || [];
  },
  loadingSquads(state) { return state.squadsLoading; },
  loadingPrivateMessages(state) { return state.privateMessagesLoading; },
};


const actions = {
  chatGetUserChannels({ commit, state }) {
    if (state.squadsLoading || state.squadsExhausted) return;

    commit(LOADING_CHAT_USER_CHANNELS, true);
    const userToken = this.getters['auth/userToken'];
    const { squadsTake: take, squadsSkip: skip } = state;
    chatGetUserChannels(userToken, { skip, take })
      .then(({ data }) => {
        commit(LOADING_CHAT_USER_CHANNELS, false);
        const status = get(data, '[1].status');
        const response = get(data, '[1]');
        if (status === 'SUCCESS') {
          const chatUserChannels = get(response, 'data', []);
          commit(GET_CHAT_USER_CHANNELS, { chatUserChannels });
        }

        if (get(data, '[1].error.error_type') === 'NO_DATA') {
          commit('USER_CHANNELS_EXHAUSTED');
        }
      })
      .catch(() => {
        commit(LOADING_CHAT_USER_CHANNELS, false);
        this.dispatch('auth/setFlashMessage', { message: 'Failed to get your messages', type: 'error' });
      });
  },
  getPrivateChatList({ commit, state }) {
    if (state.privateMessageExhausted || state.privateMessagesLoading) return;

    commit(LOADING_CHAT_PRIVATE_LIST, true);
    const userToken = this.getters['auth/userToken'];
    const { privateMessagesSkip: skip, privateMessagesTake: take } = state;
    getPrivateChatList(userToken, { skip, take })
      .then(({ data }) => {
        commit(LOADING_CHAT_PRIVATE_LIST, false);
        const privateMessages = get(data, '[1].data.details.chat_list', []);
        const userProfiles = get(data, '[1].data.details.contributors.details', []);
        commit(GET_CHAT_PRIVATE_LIST, { userProfiles, privateMessages });

        if (get(data, '[1].error.error_type') === 'NO_DATA') {
          commit('PRIVATE_LIST_EXHAUSTED');
        }
      });
  },
};


const mutations = {
  [GET_CHAT_USER_CHANNELS](state, values) {
    state.squads = [...state.squads, ...values.chatUserChannels];
    state.squadsSkip += state.squadsTake;
  },
  USER_CHANNELS_EXHAUSTED(state) {
    state.squadsExhausted = true;
  },
  [GET_CHAT_PRIVATE_LIST](state, values) {
    state.user_profiles = [...state.user_profiles, ...values.userProfiles];
    state.privateMessages = [...state.privateMessages, ...values.privateMessages];
    state.privateMessagesSkip += state.privateMessagesTake;
  },
  PRIVATE_LIST_EXHAUSTED(state) {
    state.privateMessageExhausted = true;
  },
  [LOADING_CHAT_PRIVATE_LIST](state, value) {
    state.privateMessagesLoading = value;
  },
  [LOADING_CHAT_USER_CHANNELS](state, value) {
    state.squadsLoading = value;
  },
};


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/messages.js